<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" title="Contents">
<p class="h1"><span class="right_1" epub:type="pagebreak" id="page_v" title="v"><b>CONTENTS</b></span></p>
<p class="toc" id="ch1"><a href="#/text/9780253044174_Maps">List of Maps</a></p>
<p class="toc" id="ch2"><a href="#/text/9780253044174_Preface">Preface</a></p>
<p class="toc" id="ch3"><a href="#/text/9780253044174_Acknowledgments">Acknowledgments</a></p>
<p class="toc" id="ch4"><a href="#/text/9780253044174_Glossary">Glossary</a></p>
<p class="toc-b" id="ch5"><a href="#/text/9780253044174_Abbreviations">List of Abbreviations</a></p>
<p class="toc1" id="ch6"><a href="#/text/9780253044174_Introduction">Introduction</a></p>
<p class="toc1" id="ch7"><a href="#/text/9780253044174_Chapter_01">1. The Rise of the Singapore Naval Base</a></p>
<p class="toc1" id="ch8"><a href="#/text/9780253044174_Chapter_02">2. The Allied Ground Forces in Malaya</a></p>
<p class="toc1" id="ch9"><span href="#/text/9780253044174_Chapter_03" title="Link target outside of Sample">3. The Invasion</span></p>
<p class="toc1" id="ch10"><span href="#/text/9780253044174_Chapter_04" title="Link target outside of Sample">4. Defeat at Slim River</span></p>
<p class="toc1" id="ch11"><span href="#/text/9780253044174_Chapter_05" title="Link target outside of Sample">5. Disaster at Muar and Johore</span></p>
<p class="toc1" id="ch12"><span href="#/text/9780253044174_Chapter_06" title="Link target outside of Sample">6. Endgame on Singapore Island</span></p>
<p class="toc1" id="ch13"><span href="#/text/9780253044174_Conclusion" title="Link target outside of Sample">Conclusion</span></p>
<p class="toc-t" id="ch14"><span href="#/text/9780253044174_Bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc" id="ch15"><span href="#/text/9780253044174_Index" title="Link target outside of Sample">Index</span><span class="right_1" epub:type="pagebreak" id="page_vi" title="vi"></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780253044174_Contents.vue?f6713dc2